/**
 * General constants used in all monorepo apps
 */

export const RELEASE_VERSION = 106;
